const cardBodyStyle = {
  cardBody: {
    padding: "0",
    flex: "1 1 auto",
    //color: "#999"
  }
};

export default cardBodyStyle;
